import React from "react";
import { FormBuilderImage } from "./formBuilderImage";
import { Tab as TabUntyped } from "../../secondary";
import styles from "./multiFileUploadFormBuilder.module.scss";
import type { FormBuilderQuestion, FormBuilderSection, QuestionMedia } from "../../../features/custom-forms";

const Tab = TabUntyped as unknown as React.ComponentType<{
  tabList: Array<{ name: string; key: string; content: React.ReactNode; className?: string }>;
}>;

interface MultiFileUploadFormBuilderProps {
  handleAddMediaCancel: () => void;
  questionId?: number;
  formId?: number;
  productType?: unknown;
  mediaList?: QuestionMedia;
  questionIndex: number;
  customFormBuilder: FormBuilderQuestion[];
  setcustomFormBuilder: React.Dispatch<React.SetStateAction<FormBuilderQuestion[]>>;
  setSectionInfo: React.Dispatch<React.SetStateAction<FormBuilderSection[]>>;
}

export function MultiFileUploadFormBuilder({
  handleAddMediaCancel,
  questionId,
  formId,
  productType,
  mediaList,
  questionIndex,
  customFormBuilder,
  setcustomFormBuilder,
  setSectionInfo,
}: MultiFileUploadFormBuilderProps) {
  const tabList = [
    {
      name: "Images",
      key: "images",
      content: (
        <FormBuilderImage
          handleAddMediaCancel={handleAddMediaCancel}
          questionId={questionId}
          formId={formId}
          productType={productType}
          mediaList={mediaList}
          questionIndex={questionIndex}
          customFormBuilder={customFormBuilder}
          setcustomFormBuilder={setcustomFormBuilder}
          setSectionInfo={setSectionInfo}
        />
      ),
      className: styles.no_shadow,
    },
  ];

  return (
    <div>
      <div className={styles.media_hdg}>Upload Media</div>
      <div className={styles.media_btm}>
        <Tab tabList={tabList} />
      </div>
    </div>
  );
}
